module.exports = __webpack_public_path__ + "static/media/blog-37-img2.e789e30d.webp";